import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, from, of } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable()
export class Auth0Interceptor implements HttpInterceptor {

  constructor(private readonly auth0: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept requests to your API
    if (!request.url.startsWith(environment.baseApiUrl)) {
      return next.handle(request);
    }

    // Check if user logged in via Auth0
    const isAuth0Login = sessionStorage.getItem("auth_type") === "auth0";

    if (!isAuth0Login) {
      // Normal login - don't attach token
      return next.handle(request);
    }

    // Auth0 login - attach token only if authenticated
    return this.auth0.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          // Auth0 user but not authenticated yet - skip token
          return next.handle(request);
        }

        // Authenticated via Auth0 - attach token
        return this.auth0.getAccessTokenSilently().pipe(
          take(1),
          switchMap(token => {
            const authRequest = request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            });
            return next.handle(authRequest);
          })
        );
      })
    );
  }
}
